module.exports = __webpack_public_path__ + "static/media/somaiya-ayurvihar.06ef9ee8.png";